const $f3299dfc7d184823$var$c64Palette = {
    0: "#000000",
    1: "#FFFFFF",
    2: "#A0292F",
    3: "#59DCD4",
    4: "#A82CB7",
    5: "#3FC033",
    6: "#3e32a2",
    7: "#F4F941",
    8: "#A84A14",
    9: "#643800",
    10: "#E56067",
    11: "#4A4A4A",
    12: "#7B7B7B",
    13: "#8FFF81",
    14: "#7c71db",
    15: "#B2B2B2" // Light Grey
};
let $f3299dfc7d184823$export$4f0e7e264c0ce8c4 = $f3299dfc7d184823$var$c64Palette[14];
let $f3299dfc7d184823$export$e8839f152becfa1c = $f3299dfc7d184823$var$c64Palette[6];
const $f3299dfc7d184823$export$bb47c27c34dd20d9 = ()=>{
    $f3299dfc7d184823$export$4f0e7e264c0ce8c4 = $f3299dfc7d184823$var$c64Palette[14];
    $f3299dfc7d184823$export$e8839f152becfa1c = $f3299dfc7d184823$var$c64Palette[6];
};
const $f3299dfc7d184823$export$b2ed4a58b9e91c1f = (fg = $f3299dfc7d184823$var$c64Palette[14], bg = $f3299dfc7d184823$var$c64Palette[6])=>{
    $f3299dfc7d184823$export$4f0e7e264c0ce8c4 = fg;
    $f3299dfc7d184823$export$e8839f152becfa1c = bg;
};
const $f3299dfc7d184823$export$136482fe73a0653c = (value)=>{
    const mapping = {
        black: $f3299dfc7d184823$var$c64Palette[0],
        white: $f3299dfc7d184823$var$c64Palette[1],
        red: $f3299dfc7d184823$var$c64Palette[2],
        cyan: $f3299dfc7d184823$var$c64Palette[3],
        purple: $f3299dfc7d184823$var$c64Palette[4],
        green: $f3299dfc7d184823$var$c64Palette[5],
        blue: $f3299dfc7d184823$var$c64Palette[6],
        yellow: $f3299dfc7d184823$var$c64Palette[7],
        orange: $f3299dfc7d184823$var$c64Palette[8],
        brown: $f3299dfc7d184823$var$c64Palette[9],
        "light red": $f3299dfc7d184823$var$c64Palette[10],
        lightred: $f3299dfc7d184823$var$c64Palette[10],
        "dark grey": $f3299dfc7d184823$var$c64Palette[11],
        darkgrey: $f3299dfc7d184823$var$c64Palette[11],
        grey: $f3299dfc7d184823$var$c64Palette[12],
        "light green": $f3299dfc7d184823$var$c64Palette[13],
        lightgreen: $f3299dfc7d184823$var$c64Palette[13],
        "light blue": $f3299dfc7d184823$var$c64Palette[14],
        lightblue: $f3299dfc7d184823$var$c64Palette[14],
        "light grey": $f3299dfc7d184823$var$c64Palette[15],
        lightgrey: $f3299dfc7d184823$var$c64Palette[15],
        "default_fg": $f3299dfc7d184823$export$4f0e7e264c0ce8c4,
        "default_bg": $f3299dfc7d184823$export$e8839f152becfa1c
    };
    return mapping[value.toLowerCase().trim()] || null;
};
const $f3299dfc7d184823$export$e4369cabd7e84cd9 = ()=>{
    const keys = Object.keys($f3299dfc7d184823$var$c64Palette);
    const randomIndex = Math.floor(Math.random() * keys.length);
    return $f3299dfc7d184823$var$c64Palette[keys[randomIndex]];
};
const $f3299dfc7d184823$export$459127cd7e595331 = (except)=>{
    const keys = Object.keys($f3299dfc7d184823$var$c64Palette).filter((key)=>$f3299dfc7d184823$var$c64Palette[key] !== except);
    const randomIndex = Math.floor(Math.random() * keys.length);
    return $f3299dfc7d184823$var$c64Palette[keys[randomIndex]];
};


const $7c272bbd353d7892$export$67ea982130081db = document.getElementById('terminal');
const $7c272bbd353d7892$export$39f92e86d1722f3a = $7c272bbd353d7892$export$67ea982130081db.getContext('2d');
const $7c272bbd353d7892$export$c119edd038b32682 = 320;
const $7c272bbd353d7892$export$949e8bebaebb6b76 = 200;
const $7c272bbd353d7892$export$53b3c91859018cd4 = 40;
const $7c272bbd353d7892$export$2dd197b55cf13440 = 25;
const $7c272bbd353d7892$export$e19a55101d8f7602 = 50;
const $7c272bbd353d7892$export$b42265511aa0357b = $7c272bbd353d7892$export$c119edd038b32682 / $7c272bbd353d7892$export$53b3c91859018cd4; // 8 pixels per cell.
const $7c272bbd353d7892$export$9f087e2c90470972 = $7c272bbd353d7892$export$949e8bebaebb6b76 / $7c272bbd353d7892$export$2dd197b55cf13440; // 8 pixels per cell.
// Adjust canvas for high-DPI displays.
const $7c272bbd353d7892$var$dpr = window.devicePixelRatio || 1;
$7c272bbd353d7892$export$67ea982130081db.width = $7c272bbd353d7892$export$c119edd038b32682 * $7c272bbd353d7892$var$dpr;
$7c272bbd353d7892$export$67ea982130081db.height = $7c272bbd353d7892$export$949e8bebaebb6b76 * $7c272bbd353d7892$var$dpr;
$7c272bbd353d7892$export$39f92e86d1722f3a.scale($7c272bbd353d7892$var$dpr, $7c272bbd353d7892$var$dpr);
// Set our custom font and text baseline ("top" makes positioning easier).
$7c272bbd353d7892$export$39f92e86d1722f3a.font = "8px 'C64 Pro'";
$7c272bbd353d7892$export$39f92e86d1722f3a.textBaseline = "top";
$7c272bbd353d7892$export$39f92e86d1722f3a.fillStyle = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4);


const $fdd4cfefad56b47a$export$4a6bdc0a840be00 = {
    INPUT: 0,
    BASIC: 1
};
const $fdd4cfefad56b47a$export$ca000e230c0caa3e = {
    ready: true,
    currentInput: [],
    showCursor: true,
    blockCursor: false,
    waitingForKeyPress: false,
    loadedProgram: null,
    loadedDirectory: null,
    maxValue: 1.70141183e38,
    maxLineLength: 40,
    maxStringLength: 255,
    running: false,
    goto: null,
    maxGoto: 63999,
    mode: $fdd4cfefad56b47a$export$4a6bdc0a840be00.INPUT,
    start: new Date()
};



class $dcc66b297d4615da$export$f6f0c3fe4ec306ea {
    constructor(char, fg = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), bg = (0, $f3299dfc7d184823$export$e8839f152becfa1c)){
        this.char = char;
        this.fg = fg;
        this.bg = bg;
    }
}
const $dcc66b297d4615da$export$fe9cd68599a979f2 = (text, fg = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), bg = (0, $f3299dfc7d184823$export$e8839f152becfa1c))=>Array.from(text, (ch)=>new $dcc66b297d4615da$export$f6f0c3fe4ec306ea(ch, fg, bg));
const $dcc66b297d4615da$export$56a312d8b4726b1d = (cells)=>cells.map((cell)=>cell.char).join("");
const $dcc66b297d4615da$var$padCells = (cells, width, fgColor = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), bgColor = (0, $f3299dfc7d184823$export$e8839f152becfa1c))=>{
    let padded = cells.slice();
    while(padded.length < width)padded.push(new $dcc66b297d4615da$export$f6f0c3fe4ec306ea(" ", fgColor, bgColor));
    return padded;
};
const $dcc66b297d4615da$var$centerCells = (cells, width, fgColor = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), bgColor = (0, $f3299dfc7d184823$export$e8839f152becfa1c))=>{
    const totalSpaces = width - cells.length;
    const leftPaddingCount = Math.floor(totalSpaces / 2);
    const leftPadding = Array.from({
        length: leftPaddingCount
    }, ()=>new $dcc66b297d4615da$export$f6f0c3fe4ec306ea(" ", fgColor, bgColor));
    return leftPadding.concat(cells);
};
const $dcc66b297d4615da$export$b19f13703ed1a836 = (cells, width, alignment = 'left', fgColor = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), bgColor = (0, $f3299dfc7d184823$export$e8839f152becfa1c))=>{
    if (alignment === 'center') return $dcc66b297d4615da$var$centerCells(cells, width, fgColor, bgColor);
    else if (alignment === 'right') {
        const totalSpaces = width - cells.length;
        const rightPadding = Array.from({
            length: totalSpaces
        }, ()=>new $dcc66b297d4615da$export$f6f0c3fe4ec306ea(" ", fgColor, bgColor));
        return rightPadding.concat(cells);
    } else // Default to left alignment
    return $dcc66b297d4615da$var$padCells(cells, width, fgColor, bgColor);
};


const $8c5fe36f99ec85f1$export$be623a1d3e871e62 = {
    lines: [
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("    **** COMMODORE 64 BASIC V2 ****     ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from(" 64K RAM SYSTEM  38911 BASIC BYTES FREE ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("READY.                                  ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
        Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch))
    ],
    emptyLine: ()=>Array.from("                                        ", (ch)=>new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(ch)),
    cursorPosition: [
        6,
        0
    ],
    clearScreen: async ()=>{
        // Make sure the screen is cleared before the promise is resolved.
        // This is important for the blinking cursor.
        return new Promise((resolve)=>{
            setTimeout(()=>{
                for(let i = 0; i < $8c5fe36f99ec85f1$export$be623a1d3e871e62.lines.length; i++)$8c5fe36f99ec85f1$export$be623a1d3e871e62.lines[i] = $8c5fe36f99ec85f1$export$be623a1d3e871e62.emptyLine();
                // Reset the cursor position.
                $8c5fe36f99ec85f1$export$be623a1d3e871e62.cursorPosition = [
                    0,
                    0
                ];
                resolve();
            }, 0);
        });
    }
};


const $bb03cfb7ed2a4fd8$export$fdfa2e9363bf938e = ()=>{
    // Clear the canvas.
    (0, $7c272bbd353d7892$export$39f92e86d1722f3a).clearRect(0, 0, (0, $7c272bbd353d7892$export$c119edd038b32682), (0, $7c272bbd353d7892$export$949e8bebaebb6b76));
    // Get the lines from state.
    let lines = (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines;
    // Render all lines.
    for(let i = 0; i < lines.length; i++)$bb03cfb7ed2a4fd8$var$renderLine(i, lines[i]);
    // Draw the blinking cursor at the cursor position.
    if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).showCursor && !(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor) {
        const cursorRow = (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0];
        const cursorCol = (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1];
        // At the position of the cursor, the cell is drawn with inverted colors.
        var cell = lines[cursorRow][cursorCol];
        if (cell) {
            (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillStyle = cell.fg;
            (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillRect(cursorCol * (0, $7c272bbd353d7892$export$b42265511aa0357b), cursorRow * (0, $7c272bbd353d7892$export$9f087e2c90470972), (0, $7c272bbd353d7892$export$b42265511aa0357b), (0, $7c272bbd353d7892$export$9f087e2c90470972));
            (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillStyle = cell.bg;
            (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillText(cell.char, cursorCol * (0, $7c272bbd353d7892$export$b42265511aa0357b), cursorRow * (0, $7c272bbd353d7892$export$9f087e2c90470972));
        }
    }
};
const $bb03cfb7ed2a4fd8$export$59b33278b5b2fc8a = ()=>{
    const scaleX = window.innerWidth / (0, $7c272bbd353d7892$export$c119edd038b32682);
    const scaleY = window.innerHeight / (0, $7c272bbd353d7892$export$949e8bebaebb6b76);
    const scale = Math.floor(Math.min(scaleX, scaleY));
    (0, $7c272bbd353d7892$export$67ea982130081db).style.width = (0, $7c272bbd353d7892$export$c119edd038b32682) * scale + "px";
    (0, $7c272bbd353d7892$export$67ea982130081db).style.height = (0, $7c272bbd353d7892$export$949e8bebaebb6b76) * scale + "px";
};
// Render a single line at the given row index.
const $bb03cfb7ed2a4fd8$var$renderLine = (row, cells)=>{
    for(let i = 0; i < cells.length && i < (0, $7c272bbd353d7892$export$53b3c91859018cd4); i++){
        const cell = cells[i];
        // Draw the cell background.
        (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillStyle = cell.bg;
        (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillRect(i * (0, $7c272bbd353d7892$export$b42265511aa0357b), row * (0, $7c272bbd353d7892$export$9f087e2c90470972), (0, $7c272bbd353d7892$export$b42265511aa0357b), (0, $7c272bbd353d7892$export$9f087e2c90470972));
        // Draw the character in the foreground color.
        (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillStyle = cell.fg;
        (0, $7c272bbd353d7892$export$39f92e86d1722f3a).fillText(cell.char, i * (0, $7c272bbd353d7892$export$b42265511aa0357b), row * (0, $7c272bbd353d7892$export$9f087e2c90470972));
    }
};












const $584aeef362e2949c$export$88e5af016aee27e = async (line = "", { charDelay: charDelay = 0, lineDelay: lineDelay = 0, align: align = 'left', endWithEnter: endWithEnter = true, preventCursorShift: preventCursorShift = false } = {})=>{
    // Convert the input line to a cell array.
    let cellLine = typeof line === "string" ? (0, $dcc66b297d4615da$export$fe9cd68599a979f2)(line) : line;
    // Align the cells based on the specified alignment.
    if (align !== 'left') cellLine = (0, $dcc66b297d4615da$export$b19f13703ed1a836)(cellLine, (0, $7c272bbd353d7892$export$53b3c91859018cd4), align);
    // If a character delay is set, type the line character by character.
    if (charDelay > 0) return new Promise((resolve)=>{
        let charIndex = 0;
        function typeNextChar() {
            if (charIndex < cellLine.length) {
                // Append each character (cell) to the position of the cursor.
                (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]][(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]] = cellLine[charIndex];
                // Move the cursor to the next position.
                (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]++;
                // If the cursor position exceeds the number of columns, move to the next line.
                if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] >= (0, $7c272bbd353d7892$export$53b3c91859018cd4)) {
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
                }
                // If the cursor position exceeds the number of rows, move all lines up one line and reset the cursor position to last line.
                if (!preventCursorShift && (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) (0, $6d5084239ae1c0cb$export$96e75e214ecc8805)();
                charIndex++;
                setTimeout(typeNextChar, charDelay);
            } else {
                if (endWithEnter) {
                    // Update the cursor position, so it's at the beginning of the next line.
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
                    // If the cursor position exceeds the number of rows, move all lines up one line and reset the cursor position to last line.
                    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) (0, $6d5084239ae1c0cb$export$96e75e214ecc8805)();
                }
                setTimeout(resolve, lineDelay);
            }
        }
        typeNextChar();
    });
    else {
        // Pad the line to the number of columns.
        cellLine = (0, $dcc66b297d4615da$export$b19f13703ed1a836)(cellLine, (0, $7c272bbd353d7892$export$53b3c91859018cd4), 'left');
        // If no character delay is set, print the line instantly.
        return new Promise((resolve)=>{
            // Set the line to the line where the cursor is.
            (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]] = cellLine;
            // If a line delay is set, wait for the delay before resolving.
            setTimeout(()=>{
                // If endWithEnter is false, do not move the cursor to the next line.
                if (endWithEnter) {
                    // Update the cursor position, so it's at the beginning of the next line.
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
                    // If the cursor position exceeds the number of rows, move all lines up one line and reset the cursor position to last line.
                    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) (0, $6d5084239ae1c0cb$export$96e75e214ecc8805)();
                } else if (!preventCursorShift) {
                    // Move the cursor to the end of the line. As the current line is always padded, we need to get the string value of the line.
                    const len = (0, $dcc66b297d4615da$export$56a312d8b4726b1d)(cellLine).trim().length;
                    // Move the cursor to the end of the line.
                    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = len;
                    // If the cursor position exceeds the number of columns, move to the next line.
                    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] >= (0, $7c272bbd353d7892$export$53b3c91859018cd4)) {
                        (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
                        (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
                    }
                }
                resolve();
            }, lineDelay);
        });
    }
};
const $584aeef362e2949c$export$229c72e5fdee233b = (delay, callback = null)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            if (callback) callback();
            resolve();
        }, delay);
    });
};
const $584aeef362e2949c$export$3c5f89dae98e900b = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
const $584aeef362e2949c$var$_waitForAnyKeyPress = ()=>new Promise((resolve)=>{
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).waitingForKeyPress = true; // Set the flag
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).keyPressResolve = resolve; // Store the resolve function
    });
const $584aeef362e2949c$export$f59d1a19d67724e0 = async (color)=>{
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = false;
    if (color) // Print a message in the specified color.
    await $584aeef362e2949c$export$88e5af016aee27e($584aeef362e2949c$export$51e59903ef341877(`[fg=${color}]PRESS ANY KEY TO CONTINUE...[/]`, (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), (0, $f3299dfc7d184823$export$e8839f152becfa1c)), {
        endWithEnter: false
    });
    else // Print a default message.
    await $584aeef362e2949c$export$88e5af016aee27e("PRESS ANY KEY TO CONTINUE...", {
        endWithEnter: false
    });
    await $584aeef362e2949c$var$_waitForAnyKeyPress();
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = true;
};
const $584aeef362e2949c$export$51e59903ef341877 = (input, defaultFG = (0, $f3299dfc7d184823$export$4f0e7e264c0ce8c4), defaultBG = (0, $f3299dfc7d184823$export$e8839f152becfa1c))=>{
    const result = [];
    let currentIndex = 0;
    // This regex finds segments that begin with [<attributes>] and end with [/].
    //   Group 1: The attributes e.g., "fg=yellow" or "fg=yellow,bg=blue"
    //   Group 2: The text within the tags.
    const regex = /\[([^\]]+)\](.*?)\[\/\]/gs;
    let match;
    while((match = regex.exec(input)) !== null){
        // First, add any plain text preceding this styled segment.
        if (match.index > currentIndex) {
            const plainText = input.slice(currentIndex, match.index);
            result.push(...(0, $dcc66b297d4615da$export$fe9cd68599a979f2)(plainText, defaultFG, defaultBG));
        }
        // Process the attributes.
        const attributes = match[1].split(",").map((attr)=>attr.trim());
        let fg = defaultFG;
        let bg = defaultBG;
        attributes.forEach((attr)=>{
            const [key, value] = attr.split("=");
            if (key && value) {
                if (key.toLowerCase() === "fg") {
                    const parsed = (0, $f3299dfc7d184823$export$136482fe73a0653c)(value);
                    if (parsed) fg = parsed;
                } else if (key.toLowerCase() === "bg") {
                    const parsed = (0, $f3299dfc7d184823$export$136482fe73a0653c)(value);
                    if (parsed) bg = parsed;
                }
            }
        });
        // Convert the styled text segment into an array of Cells.
        const styledText = match[2];
        result.push(...(0, $dcc66b297d4615da$export$fe9cd68599a979f2)(styledText, fg, bg));
        // Update the current index to the end of this match.
        currentIndex = regex.lastIndex;
    }
    // Append any remaining plain text after the last match.
    if (currentIndex < input.length) {
        const plainText = input.slice(currentIndex);
        result.push(...(0, $dcc66b297d4615da$export$fe9cd68599a979f2)(plainText, defaultFG, defaultBG));
    }
    return result;
};
const $584aeef362e2949c$export$1d08dd77a241520a = (input)=>input.replace(/\[.*?\]/g, ""); // Removes all formatting codes
const $584aeef362e2949c$export$6a0c4e84627b47c1 = async (expr, context = {})=>{
    // Validate the expression.
    // Allow digits, decimal points, spaces, arithmetic operators, parentheses, variable/function names, and strings in double quotes.
    // Exclude content inside double quotes from validation.
    const strippedExpr = expr.replace(/"[^"]*"/g, '""'); // Replace content inside double quotes with empty quotes.
    if (!/^[\d+\-*/%().\s\w"$]+$/.test(strippedExpr)) throw new Error("Expression contains illegal characters.");
    // Match all function calls in the expression (e.g., ABS(-3)).
    const functionCallRegex = /(\w+\$?)\(([^()]+)\)/g;
    let match;
    // Resolve all function calls asynchronously.
    while((match = functionCallRegex.exec(expr)) !== null){
        const [fullMatch, functionName, args] = match;
        // Check if the function exists in the context.
        if (context[functionName]) {
            // Call the function with the evaluated arguments.
            const resolvedValue = await context[functionName](await $584aeef362e2949c$export$6a0c4e84627b47c1(args, context));
            // Ensure the resolved value is properly quoted if it's a string.
            const resolvedString = typeof resolvedValue === "string" ? `"${resolvedValue}"` : resolvedValue;
            // Replace the function call in the expression with its resolved value.
            expr = expr.replace(fullMatch, resolvedString);
            // Reset the regex search to ensure all function calls are processed.
            functionCallRegex.lastIndex = 0;
        } else throw new Error(`Function "${functionName}" not found in context.`);
    }
    // Evaluate the final expression synchronously.
    const contextKeys = Object.keys(context);
    const contextValues = Object.values(context);
    const func = new Function(...contextKeys, `return ${expr};`);
    // Evaluate the expression and handle concatenation of strings and numbers.
    const result = func(...contextValues);
    // If the result is a string, remove the surrounding quotes.
    if (typeof result === "string") return result.replace(/^"|"$/g, "");
    return result;
};


class $0aba7663dfb52ff8$export$a490eb03cb7a0a5e extends Error {
    constructor(message){
        super(message);
        this.name = "BaseError";
    }
    async handleError() {
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)(`?${this.name}  ERROR`);
    }
}
class $0aba7663dfb52ff8$export$dbf2365ccb60f5d {
    constructor(message, lineNumber){
        this.message = message;
        this.lineNumber = lineNumber;
    }
    async handleError() {
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)(`?SYNTAX  ERROR IN ${this.lineNumber}`);
    }
}
class $0aba7663dfb52ff8$export$f21cea08b0dd60e8 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "SYNTAX";
    }
}
class $0aba7663dfb52ff8$export$6dd8bd6e07dce31b extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "UNDEF'D STATEMENT";
    }
}
class $0aba7663dfb52ff8$export$40ed5092119045f8 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "DEVICE NOT PRESENT";
    }
}
class $0aba7663dfb52ff8$export$985361d9917e9b3 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "TYPE MISMATCH";
    }
}
class $0aba7663dfb52ff8$export$8ed883a370ca9eb3 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "MISSING FILE NAME";
    }
}
class $0aba7663dfb52ff8$export$e98f741f94e263de extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "OVERFLOW";
    }
}
class $0aba7663dfb52ff8$export$61ccfd3d52a5b775 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "DIVISION BY ZERO";
    }
}
class $0aba7663dfb52ff8$export$301956b3a870f3d8 extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "ILLEGAL QUANTITY";
    }
}
class $0aba7663dfb52ff8$export$86c7c1ef686e462b extends $0aba7663dfb52ff8$export$a490eb03cb7a0a5e {
    constructor(message){
        super(message);
        this.name = "STRING TOO LONG";
    }
}







const $6c4015088de7264d$export$2335f513bbd82c6d = async (args)=>{
    // Example of valid args:
    // ABS(-10) (Screen: 10)
    // ABS(-10-11+5) (Screen: 16)
    // ABS("Text") (Screen: ?TYPE MISMATCH  ERROR)
    // ABS() (Screen: ?SYNTAX  ERROR)
    // Check if args are a number or a mathematical expression.
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    const result = Math.abs(args);
    // Check if the result is within the range of a floating point value.
    if (result > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the absolute value of the result.
    return result;
};



const $32e00bdac62ae68b$export$debe6e778e0a6d32 = async (args)=>{
    // Example of valid args:
    // ASC("A") (Screen: 65)
    // ASC("AB") (Screen: 65)
    // ASC("") (Screen: ?ILLEGAL QUANTITY ERROR)
    // ASC(123) (Screen: ?TYPE MISMATCH ERROR)
    // ASC() (Screen: ?SYNTAX ERROR)
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$301956b3a870f3d8();
    // Check if the args is a string.
    if (typeof args !== "string") throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    const result = args.charCodeAt(0);
    // Check if the result is within the range of a Commodore ASCII value.
    if (result < 0 || result > 255) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    return result;
};




const $cb2781bcc5842578$export$514b701045f1b7ab = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Calculate the arc tangent.
    const result = Math.atan(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $c85221e271a1e942$export$50d414a77b60d802 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Calculate the cosine.
    const result = Math.cos(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $c980534fe01db0dd$export$5de3937cb4b592ed = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check for overflow.
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Calculate the sine.
    const result = Math.sin(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $5137449731cd2863$export$fcdd3b0b3246a325 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Check for division by zero (if the argument is +/-π/2).
    if (args === Math.PI / 2 || args === -Math.PI / 2) throw new $0aba7663dfb52ff8$export$61ccfd3d52a5b775();
    // Calculate the tangent.
    const result = Math.tan(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $cbf56abfa5920ac2$export$b310ec824aaee37f = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check for overflow.
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Calculate the exponential.
    if (args < -89.0296919) return 0;
    const result = Math.exp(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $69905186e3f53fd5$export$bef1f36f5486a6a3 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check for illegal quantity.
    if (args <= 0) throw new $0aba7663dfb52ff8$export$301956b3a870f3d8();
    // Check for overflow.
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Calculate the logarithm.
    const result = Math.log(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




// Internal seed for the PRNG sequence.
let $751b90894d42ae26$var$currentSeed = 1;
// Linear Congruential Generator (LCG) for pseudo-random numbers.
const $751b90894d42ae26$var$lcg = (seed)=>{
    const a = 1664525; // Multiplier
    const c = 1013904223; // Increment
    const m = 2 ** 32; // Modulus
    return (a * seed + c) % m;
};
// Generate a random number between 0.0 (inclusive) and 1.0 (exclusive) using the LCG.
const $751b90894d42ae26$var$randomFromSeed = (seed)=>{
    const nextSeed = $751b90894d42ae26$var$lcg(seed);
    $751b90894d42ae26$var$currentSeed = nextSeed; // Update the global seed
    return nextSeed / 2 ** 32; // Normalize to [0, 1)
};
const $751b90894d42ae26$export$e87bfa2a4c6bccb0 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check for overflow.
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    const num = Number(args);
    if (num > 0) // Positive number: Generate a random number from the current sequence.
    return $751b90894d42ae26$var$randomFromSeed($751b90894d42ae26$var$currentSeed);
    else if (num < 0) {
        // Negative number: Use the absolute value of the number as the seed.
        $751b90894d42ae26$var$currentSeed = Math.abs(num);
        return $751b90894d42ae26$var$randomFromSeed($751b90894d42ae26$var$currentSeed);
    } else {
        // Zero: Generate a random number based on the current time.
        const timeSeed = Date.now() % 2 ** 32; // Use the current time as a seed
        return $751b90894d42ae26$var$randomFromSeed(timeSeed);
    }
};




const $330a0078a76dafc9$export$b02c28252f48c6ac = async (args)=>{
    // If no args are given, throw a syntax error.
    if (!args || args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a string.
    if (typeof args !== "string") throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check if the string is not too long.
    if (args.length > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxStringLength) throw new $0aba7663dfb52ff8$export$86c7c1ef686e462b();
    // Remove spaces and extract the first valid numerical value.
    const cleanedInput = args.replace(/\s+/g, ""); // Remove all spaces.
    const match = cleanedInput.match(/^[-+]?\d*\.?\d*(e[-+]?\d+)?/i); // Match a valid number.
    if (!match || match[0] === "") // If no valid number is found, return 0.
    return 0;
    // Parse the matched number.
    const result = parseFloat(match[0]);
    // Check for overflow (if the result is not a finite number or exceeds the range).
    if (!isFinite(result) || Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the parsed number.
    return result;
};




const $c409de34238d74fb$export$9bfc20ac23a61b96 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Check for negative values.
    if (args < 0) throw new $0aba7663dfb52ff8$export$301956b3a870f3d8();
    // Calculate the square root.
    const result = Math.sqrt(args);
    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the result.
    return result;
};




const $db24cadb145db3e7$export$42d51816ce590c93 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Convert the number to a string.
    return String(args);
};




const $472e6d43b11cb817$export$2fef8ec835a7bac8 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check for illegal quantity.
    if (args < 0 || args > 255) throw new $0aba7663dfb52ff8$export$301956b3a870f3d8();
    // Create a string with the specified number of spaces.
    return " ".repeat(args);
};




const $5068bdf7f60aed9b$export$fc1400facf92c78 = async (args)=>{
    // If no args are given, throw a syntax error.
    if (!args || args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the args is a string.
    if (typeof args !== "string") throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    // Check if the string is not too long.
    if (args.length > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxStringLength) throw new $0aba7663dfb52ff8$export$86c7c1ef686e462b();
    // Return the length of the string.
    return args.length;
};




const $49d45883504f6a8e$export$7d260a2a5f8bc19e = async (args)=>{
    // Example of valid args:
    // INT(10.5) (Screen: 10)
    // INT(-10.5) (Screen: -11)
    // INT("Text") (Screen: ?TYPE MISMATCH  ERROR)
    // INT() (Screen: ?SYNTAX  ERROR)
    // Check if args are a number or a mathematical expression.
    // If no args are given, throw a syntax error.
    if (args.length === 0) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    if (Math.abs(args) > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Check if the args is a number.
    if (isNaN(args)) throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    const result = Math.floor(args);
    // Check if the result is within the range of a floating point value.
    if (result > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxValue) throw new $0aba7663dfb52ff8$export$e98f741f94e263de();
    // Return the integer part of the result.
    return result;
};



const $a0f6591c8eb6bd3e$export$2da9be4cfdb689b1 = ()=>Math.floor((new Date() - (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).start) / (1000 / 60)); // 1/60 second increments, called jiffies


const $888fe5edcd3affc9$export$c2d084dc44961371 = async (args)=>{
    // Trim the args to remove leading and trailing spaces.
    args = args.trim();
    // Check if args are empty or undefined.
    if (args === undefined || args.length === 0) {
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        return;
    }
    // Preprocess the input to add concatenation operators where needed.
    let newArgs = $888fe5edcd3affc9$var$preprocessInput(args);
    while(newArgs !== args){
        args = newArgs;
        newArgs = $888fe5edcd3affc9$var$preprocessInput(args);
    }
    args = newArgs;
    // Define the context for functions & variables.
    const context = {
        ABS: (0, $6c4015088de7264d$export$2335f513bbd82c6d),
        ASC: (0, $32e00bdac62ae68b$export$debe6e778e0a6d32),
        ATN: (0, $cb2781bcc5842578$export$514b701045f1b7ab),
        COS: (0, $c85221e271a1e942$export$50d414a77b60d802),
        SIN: (0, $c980534fe01db0dd$export$5de3937cb4b592ed),
        TAN: (0, $5137449731cd2863$export$fcdd3b0b3246a325),
        EXP: (0, $cbf56abfa5920ac2$export$b310ec824aaee37f),
        LOG: (0, $69905186e3f53fd5$export$bef1f36f5486a6a3),
        RND: (0, $751b90894d42ae26$export$e87bfa2a4c6bccb0),
        VAL: (0, $330a0078a76dafc9$export$b02c28252f48c6ac),
        SQR: (0, $c409de34238d74fb$export$9bfc20ac23a61b96),
        STR$: (0, $db24cadb145db3e7$export$42d51816ce590c93),
        SPC: (0, $472e6d43b11cb817$export$2fef8ec835a7bac8),
        LEN: (0, $5068bdf7f60aed9b$export$fc1400facf92c78),
        INT: (0, $49d45883504f6a8e$export$7d260a2a5f8bc19e),
        get TI () {
            return (0, $a0f6591c8eb6bd3e$export$2da9be4cfdb689b1)();
        },
        get TIME () {
            return (0, $a0f6591c8eb6bd3e$export$2da9be4cfdb689b1)();
        }
    };
    let result;
    try {
        // Evaluate the preprocessed input.
        result = await (0, $584aeef362e2949c$export$6a0c4e84627b47c1)(args, context);
        if (typeof result === "function") {
            result = await result(); // If the result is a function, call it.
            // If the result is a function, set result to 0.
            if (typeof result === "function") result = 0;
        }
    } catch (error) {
        if (error instanceof $0aba7663dfb52ff8$export$a490eb03cb7a0a5e) {
            await error.handleError();
            return;
        } else {
            await SyntaxError.handleError();
            return;
        // console.error(error);
        // result = 0;
        }
    }
    // Print the result.
    if (!isNaN(result) && result >= 0) result = " " + String(result);
    // Print the result, splitting it into chunks of 40 characters if necessary.
    // Let the result string be a maximum length of 255 characters.
    result = String(result);
    if (result.length > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxStringLength) result = result.slice(0, (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxStringLength);
    for(let i = 0; i < result.length; i += (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxLineLength)await (0, $584aeef362e2949c$export$88e5af016aee27e)(result.slice(i, i + (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxLineLength));
    if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).mode === (0, $fdd4cfefad56b47a$export$4a6bdc0a840be00).INPUT) // If in input mode, print the prompt.
    await (0, $584aeef362e2949c$export$88e5af016aee27e)();
};
/**
 * Preprocesses the input to add concatenation operators where needed.
 * @param {string} input - The input string to preprocess.
 * @returns {string} The preprocessed input.
 */ const $888fe5edcd3affc9$var$preprocessInput = (input)=>{
    // Add a "+" between a string, function call, or number if no operator is present.
    return input// Handle cases where there are no spaces between tokens.
    .replace(/(".*?"|\d+)(\w+\()/g, '$1+$2') // String/number followed by a function call.
    .replace(/(\w+\))(".*?"|\d+)/g, '$1+$2') // Function call followed by a string/number.
    .replace(/(".*?"|\w+\(.*?\)|\d+)\s+(".*?"|\w+\(.*?\)|\d+)/g, '$1+$2'); // Handle spaces between tokens.
};








const $19964ed1e9426bb3$export$ee72801824c03e63 = {
    name: "about",
    size: 44,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("32 SYS 4096"); // Simulate the 'list' command when this program is loaded
    },
    run: async ()=>{
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = false;
        const refDate = new Date("2011-03-01");
        const today = new Date();
        let yearsWork = today.getFullYear() - refDate.getFullYear();
        if (today.getMonth() < refDate.getMonth() || today.getMonth() === refDate.getMonth() && today.getDate() < refDate.getDate()) yearsWork--;
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("HI, I'M [fg=yellow]DENNIS SMIT[/], A PROUD DAD,"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=yellow]BOARD[/] AND [fg=yellow]VIDEO[/] GAME ENTHUSIAST, AND"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("AN ALLROUND GEEK WITH A PASSION FOR", {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=yellow]INNOVATION[/]."), {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("EVER SINCE I GOT MY FIRST COMPUTER, A", {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]COMMODORE 64[/], AT THE AGE OF [fg=white]10[/], I AM"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("EXPLORING THE WORLD OF PROGRAMMING."), {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[bg=default_fg,fg=default_bg]THIS SITE IS A HOMAGE TO THAT ICONIC PC![/]"), {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("BASED IN UTRECHT, THE [fg=orange]NETHERLANDS[/], I'VE"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("SPENT OVER [fg=orange]" + yearsWork + "[/] YEARS CREATING ALL KINDS"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("OF [fg=orange]EXCITING[/] DIGITAL SOLUTIONS."), {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("EARLY [fg=cyan]2025[/] I'VE CO-FOUNDED [fg=cyan]SHOOT THE[/]"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=cyan]PENGUIN STUDIOS[/], A GAME DEVELOPMENT"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("STUDIO SPECIALIZING IN [fg=cyan]UNITY[/]."), {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("WE ARE CURRENTLY WORKING ON OUR FIRST", {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("GAME AND ARE EXCITED TO SHARE MORE", {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("ABOUT IT SOON, SO STAY TUNED!", {
            charDelay: 50,
            lineDelay: 1000
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("GET IN TOUCH IF YOU LIKE TO HAVE A [fg=purple]CHAT[/]"), {
            charDelay: 50,
            lineDelay: 50
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("OR JUST WANT TO SAY [fg=purple]HELLO[/]!"), {
            charDelay: 50,
            lineDelay: 5000
        });
    }
};




const $73398406f2db4ff6$export$ee72801824c03e63 = {
    name: "dss solutions",
    size: 23,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("6 SYS 2341"); // Simulate the 'list' command when this program is loaded
    },
    run: async ()=>{
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]***[/] [fg=yellow]WELCOME TO DSS SOLUTIONS[/] [fg=white]***[/]"), {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("THIS SITE TRIES TO EMULATE A C64", {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("USING ONLY JAVASCRIPT, HTML AND CSS", {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("FOR A FULL LIST OF COMMANDS", {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("LOAD AND RUN THE [fg=white]HELP[/] PROGRAM"), {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]***[/] [fg=yellow]HAVE FUN![/] [fg=white]***[/]"), {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
    }
};



















const $a84703822ced8ce3$var$processUnsupportedFunction = async ()=>await new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)().handleError();
const $a84703822ced8ce3$var$unsupportedFunction = $a84703822ced8ce3$var$processUnsupportedFunction;
const $a84703822ced8ce3$export$18af1f934c132a41 = {
    ABS: async (args)=>await (0, $6c4015088de7264d$export$2335f513bbd82c6d)(args),
    AND: $a84703822ced8ce3$var$unsupportedFunction,
    ASC: $a84703822ced8ce3$var$unsupportedFunction,
    ATN: async (args)=>await (0, $cb2781bcc5842578$export$514b701045f1b7ab)(args),
    CHR$: $a84703822ced8ce3$var$unsupportedFunction,
    COS: async (args)=>await (0, $c85221e271a1e942$export$50d414a77b60d802)(args),
    EXP: async (args)=>await (0, $cbf56abfa5920ac2$export$b310ec824aaee37f)(args),
    FN: $a84703822ced8ce3$var$unsupportedFunction,
    FRE: $a84703822ced8ce3$var$unsupportedFunction,
    INT: async (args)=>(0, $49d45883504f6a8e$export$7d260a2a5f8bc19e)(args),
    LEFT$: $a84703822ced8ce3$var$unsupportedFunction,
    LEN: async (args)=>(0, $5068bdf7f60aed9b$export$fc1400facf92c78)(args),
    LOG: async (args)=>(0, $69905186e3f53fd5$export$bef1f36f5486a6a3)(args),
    MID$: $a84703822ced8ce3$var$unsupportedFunction,
    NOT: $a84703822ced8ce3$var$unsupportedFunction,
    OR: $a84703822ced8ce3$var$unsupportedFunction,
    PEEK: $a84703822ced8ce3$var$unsupportedFunction,
    POS: $a84703822ced8ce3$var$unsupportedFunction,
    RIGHT$: $a84703822ced8ce3$var$unsupportedFunction,
    RND: async (args)=>await (0, $751b90894d42ae26$export$e87bfa2a4c6bccb0)(args),
    SGN: $a84703822ced8ce3$var$unsupportedFunction,
    SIN: async (args)=>await (0, $c980534fe01db0dd$export$5de3937cb4b592ed)(args),
    SPC: async (args)=>await (0, $472e6d43b11cb817$export$2fef8ec835a7bac8)(args),
    SQR: async (args)=>await (0, $c409de34238d74fb$export$9bfc20ac23a61b96)(args),
    STR$: async (args)=>await (0, $db24cadb145db3e7$export$42d51816ce590c93)(args),
    TAB: $a84703822ced8ce3$var$unsupportedFunction,
    TAN: async (args)=>await (0, $5137449731cd2863$export$fcdd3b0b3246a325)(args),
    USR: $a84703822ced8ce3$var$unsupportedFunction,
    VAL: async (args)=>await (0, $330a0078a76dafc9$export$b02c28252f48c6ac)(args)
};
const $a84703822ced8ce3$export$bcba61f8b2da5198 = (functionName)=>$a84703822ced8ce3$export$18af1f934c132a41.hasOwnProperty(functionName) && $a84703822ced8ce3$export$18af1f934c132a41[functionName] !== $a84703822ced8ce3$var$unsupportedFunction;




const $bddb8a856a559ce7$var$processUnsupportedVariable = async ()=>await new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)().handleError();
const $bddb8a856a559ce7$var$unsupportedVariable = $bddb8a856a559ce7$var$processUnsupportedVariable;
const $bddb8a856a559ce7$export$44c6a27b41bcee9f = {
    TI: (0, $a0f6591c8eb6bd3e$export$2da9be4cfdb689b1)(),
    TIME: (0, $a0f6591c8eb6bd3e$export$2da9be4cfdb689b1)(),
    TI$: $bddb8a856a559ce7$var$unsupportedVariable,
    TIME$: $bddb8a856a559ce7$var$unsupportedVariable
};
const $bddb8a856a559ce7$export$f1ef15e9904f231a = (variableName)=>$bddb8a856a559ce7$export$44c6a27b41bcee9f.hasOwnProperty(variableName) && $bddb8a856a559ce7$export$44c6a27b41bcee9f[variableName] !== $bddb8a856a559ce7$var$unsupportedVariable;



const $764b50c2d678d401$export$ee72801824c03e63 = {
    name: "help",
    size: 173,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("69 SYS 42590"); // Simulate the 'list' command when this program is loaded
    },
    run: async function() {
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]THIS SITE TRIES EMULATING A COMMODORE 64[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]THE FOLLOWING IS A FULL LIST OF BASIC[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]KEYWORDS AND THEIR IMPLEMENTATION STATUS[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]FOR MORE INFO, VISIT:[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]HTTPS://C64-WIKI.COM/WIKI/BASIC_V2[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$f59d1a19d67724e0)("white");
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]########################################[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]#                                      #[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]#  BASIC KEYWORD  | IMPLEMENTED:[/][fg=green]YES[/][fg=white]/[/][fg=lightred]NO[/] [fg=white]#[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]#   ---------------------------------  #[/]"));
        // Loop through all commands and print them; if the command is not implemented, print it in red.
        let counter = 4;
        // Combine commands, functions, and variables into a single object for iteration.
        const allKeywords = {
            ...(0, $c973ce7613e80019$export$2ccc4f72dd956183),
            ...(0, $a84703822ced8ce3$export$18af1f934c132a41),
            ...(0, $bddb8a856a559ce7$export$44c6a27b41bcee9f)
        };
        // Order the keywords alphabetically.
        const sortedKeywords = Object.keys(allKeywords).sort();
        // Iterate through the sorted keywords and print each one.
        for (const keyword of sortedKeywords){
            const line = this._getLine(keyword);
            await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)(line));
            counter++;
            // If 24 keywords have been printed, wait for a keypress.
            if (counter % 24 === 0) await (0, $584aeef362e2949c$export$f59d1a19d67724e0)("white");
        }
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]#   ---------------------------------  #[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]#                                      #[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]########################################[/]"));
    },
    _getLine (name) {
        const supported = $764b50c2d678d401$var$isSupported(name);
        const color = supported ? "green" : "lightred";
        const desc = $764b50c2d678d401$var$descriptions[name] || "";
        let line = `[fg=white]#[/]   [fg=${color}]${name.toUpperCase()}[/]`;
        let visibleLine = (0, $584aeef362e2949c$export$1d08dd77a241520a)(line);
        let paddingNeeded = 12 - visibleLine.length;
        if (paddingNeeded > 0) line += " ".repeat(paddingNeeded);
        line += `[fg=white]|[/] [fg=${color}]${desc}[/]`;
        visibleLine = (0, $584aeef362e2949c$export$1d08dd77a241520a)(line);
        paddingNeeded = 39 - visibleLine.length;
        if (paddingNeeded > 0) line += " ".repeat(paddingNeeded);
        line += "[fg=white]#[/]";
        return line;
    }
};
const $764b50c2d678d401$var$isSupported = (name)=>(0, $c973ce7613e80019$export$f5bd41ed0736d1dc)(name) || (0, $a84703822ced8ce3$export$bcba61f8b2da5198)(name) || (0, $bddb8a856a559ce7$export$f1ef15e9904f231a)(name);
// 1234567890123456789012345678901234567890
// #   ---------------------------------  #
// #   1234567 | MAX 23 CHARACTERS        #
const $764b50c2d678d401$var$descriptions = {
    "?": "COMMAND",
    ABS: "NUMERIC FUNCTION",
    AND: "BOOL/BITWISE OPERATOR",
    ASC: "NUMERICAL FUNCTION",
    ATN: "NUMERIC FUNCTION",
    CHR$: "STRING FUNCTION",
    CLOSE: "COMMAND",
    CLR: "COMMAND",
    CMD: "COMMAND",
    CONT: "COMMAND",
    COS: "NUMERIC FUNCTION",
    DATA: "COMMAND",
    DEF: "COMMAND",
    DIM: "COMMAND",
    END: "COMMAND",
    EXP: "NUMERIC FUNCTION",
    FN: "NUMERIC FUNCTION",
    FOR: "COMMAND",
    FRE: "FUNCTION",
    GET: "COMMAND",
    "GET#": "COMMAND",
    GOSUB: "COMMAND",
    GOTO: "COMMAND",
    IF: "COMMAND",
    INPUT: "COMMAND",
    "INPUT#": "COMMAND",
    INT: "INTEGER FUNCTION",
    LEFT$: "STRING FUNCTION",
    LEN: "NUMERIC FUNCTION",
    LET: "COMMAND",
    LIST: "COMMAND",
    LOAD: "COMMAND",
    LOG: "NUMERIC FUNCTION",
    MID$: "STRING FUNCTION",
    NEW: "COMMAND",
    NEXT: "COMMAND",
    NOT: "BOOL/BITWISE OPERATOR",
    ON: "COMMAND",
    OPEN: "COMMAND",
    OR: "BOOL/BITWISE OPERATOR",
    PEEK: "INTEGER FUNCTION",
    POKE: "COMMAND",
    POS: "INTEGER FUNCTION",
    PRINT: "COMMAND",
    "PRINT#": "COMMAND",
    READ: "COMMAND",
    REM: "COMMAND",
    RESTORE: "COMMAND",
    RETURN: "COMMAND",
    RIGHT$: "STRING FUNCTION",
    RND: "FUNCTION",
    RUN: "COMMAND",
    SAVE: "STATEMENT",
    SGN: "NUMERIC FUNCTION",
    SIN: "NUMERIC FUNCTION",
    SPC: "FUNCTION",
    SQR: "NUMERIC FUNCTION",
    ST: "SYSTEM VARIABLE",
    STATUS: "SYSTEM VARIABLE",
    STEP: "KEYWORD PART",
    STOP: "COMMAND",
    STR$: "STRING FUNCTION",
    SYS: "COMMAND",
    TAB: "FUNCTION",
    TAN: "NUMERIC FUNCTION",
    THEN: "KEYWORD PART",
    TI: "SYSTEM VARIABLE",
    TI$: "SYSTEM VARIABLE",
    TIME: "SYSTEM VARIABLE",
    TIME$: "SYSTEM VARIABLE",
    TO: "KEYWORD PART",
    USR: "FLOATING POINT FUNCTION",
    VAL: "NUMERIC FUNCTION",
    VERIFY: "COMMAND",
    WAIT: "COMMAND"
};




const $2b85972f31e2f536$export$ee72801824c03e63 = {
    name: "contact",
    size: 27,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("16 SYS 1822"); // Simulate the 'list' command when this program is loaded
    },
    run: async ()=>{
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]***[/] [fg=yellow]!CONTACT ME![/] [fg=white]***[/]"), {
            align: 'center'
        });
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]W   :[/]               [fg=yellow]www.dss-solutions.nl[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]E   :[/]              [fg=yellow]info@dss-solutions.nl[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]LI  :[/] [fg=yellow]linkedin.com/company/dss-solutions[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]STPS:[/][fg=yellow]www.shoot-the-penguin-studios.games[/]"));
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)();
        await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("[fg=white]***[/] [fg=yellow]!CONTACT ME![/] [fg=white]***[/]"), {
            align: 'center'
        });
    }
};







const $e067660af56602a2$export$ee72801824c03e63 = {
    name: "486",
    size: 69,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("18 SYS 4112"); // Simulate the 'list' command when this program is loaded
    },
    run: async ()=>{
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = true;
        const DIGITS_486 = [
            "........................................",
            "........................................",
            "........................................",
            ".......##..........###..........#####...",
            "......###.........#####........######...",
            ".....####........##...##......##........",
            "....##.##.......##.....##....##.........",
            "...##..##......##.......##..##..........",
            "..##...##......##.......##..##..........",
            ".##....##......##.......##..##..........",
            ".##....##.......##.....##...##..........",
            ".##....##........##...##....##..........",
            ".############.....#####.....##.######...",
            ".############....#######....##########..",
            ".......##.......##.....##...##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##.......##.....##....##.....##..",
            ".......##........##...##......##...##...",
            ".......##.........#####........#####....",
            ".......##..........###..........###.....",
            "........................................",
            "........................................",
            "........................................"
        ];
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        const fgColor = (0, $f3299dfc7d184823$export$e4369cabd7e84cd9)();
        for(let i = 0; i < DIGITS_486.length; i++){
            let line = [];
            for(let j = 0; j < DIGITS_486[i].length; j++)if (DIGITS_486[i][j] === "#") line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, fgColor));
            else {
                const color = (0, $f3299dfc7d184823$export$459127cd7e595331)(fgColor);
                line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, color));
            }
            if (i === DIGITS_486.length - 1) await (0, $584aeef362e2949c$export$88e5af016aee27e)(line, {
                charDelay: 1,
                lineDelay: 1,
                endWithEnter: false,
                preventCursorShift: true
            });
            else await (0, $584aeef362e2949c$export$88e5af016aee27e)(line, {
                charDelay: 1,
                lineDelay: 1,
                endWithEnter: false
            });
        }
        setTimeout(()=>{
            window.location.href = "https://486.dss-solutions.nl"; // Redirect to the 486 page  
        }, 5000);
        await (0, $584aeef362e2949c$export$229c72e5fdee233b)(10000);
    }
};






const $a64cbae954c5941d$export$ee72801824c03e63 = {
    name: "STPS",
    size: 78,
    list: async ()=>{
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("31 SYS 2735"); // Simulate the 'list' command when this program is loaded
    },
    run: async ()=>{
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = true;
        // Create a bitmap of the STPS logo
        const BITMAP = [
            "........................................",
            "........................................",
            "........................................",
            "........................OOO.............",
            "...........YYY.........OOO..............",
            ".............YY.YYYBBBOOOO..............",
            ".........YYYYYYYYBBBBBBOO...............",
            ".........Y...YYYBBBWO.BBO...............",
            "............YY.BBBBWOOBBB...............",
            "...........YY.BBBBBWWWBBB...............",
            "..........YY.BBBBBBBBBBBB...............",
            ".............BBBBBBBBBBBB...............",
            "..............BBBBBBBBBBB...............",
            "...............BBBBBBBBBB...............",
            "................BBBBBBWWBB..............",
            ".................BBBBBWWWB..............",
            ".................BBBBWWWWBB.............",
            ".................BBBBWWWWWB.............",
            ".................BBBBWWWWWB.............",
            "................BBBBBWWWWWWB............",
            "................BBBBBWWWWWWW............",
            "...............BBBBBWWWWWWWW............",
            "..............BBBBBBWWWWWWWWW...........",
            ".............BBBBBBBWWWWWWWWW...........",
            "............BBBBBBBWWWWWWWWWW..........."
        ];
        await (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).clearScreen();
        for(let i = 0; i < BITMAP.length; i++){
            let line = [];
            for(let j = 0; j < BITMAP[i].length; j++)switch(BITMAP[i][j]){
                case "O":
                    line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, "orange"));
                    break;
                case "Y":
                    line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, "yellow"));
                    break;
                case "B":
                    line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, "black"));
                    break;
                case "W":
                    line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, "white"));
                    break;
                default:
                    line.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ", null, "blue"));
            }
            if (i === BITMAP.length - 1) await (0, $584aeef362e2949c$export$88e5af016aee27e)(line, {
                charDelay: 1,
                lineDelay: 1,
                endWithEnter: false,
                preventCursorShift: true
            });
            else await (0, $584aeef362e2949c$export$88e5af016aee27e)(line, {
                charDelay: 1,
                lineDelay: 1,
                endWithEnter: false
            });
        }
        setTimeout(()=>{
            window.location.href = "https://www.shoot-the-penguin-studios.games"; // Redirect to the STPS page  
        }, 5000);
        await (0, $584aeef362e2949c$export$229c72e5fdee233b)(10000);
    }
};


const $8a880d67ea505346$export$7f4c6ae6cd2bdde3 = [
    (0, $19964ed1e9426bb3$export$ee72801824c03e63),
    (0, $73398406f2db4ff6$export$ee72801824c03e63),
    (0, $764b50c2d678d401$export$ee72801824c03e63),
    (0, $2b85972f31e2f536$export$ee72801824c03e63),
    (0, $e067660af56602a2$export$ee72801824c03e63),
    (0, $a64cbae954c5941d$export$ee72801824c03e63)
];


const $6cbaab98018a1399$export$11e63f7b0f3d9900 = async (args)=>{
    args = args.trim();
    // If no arguments, throw load error.
    if (!args) throw new $0aba7663dfb52ff8$export$8ed883a370ca9eb3();
    // Parse the arguments.
    const parsedArgs = $6cbaab98018a1399$var$parseArgs(args);
    // Throw an error if there are no arguments.
    if (parsedArgs.length === 0) throw new $0aba7663dfb52ff8$export$8ed883a370ca9eb3();
    // Throw an error if there are more than 3 arguments.
    if (parsedArgs.length > 3) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Get the program name.
    let program = parsedArgs[0].toUpperCase();
    let device = "0";
    let secondaryAddress = "1";
    if (parsedArgs.length >= 2) // Get the device number.
    device = parsedArgs[1];
    if (parsedArgs.length === 3) // Get the secondary address.
    secondaryAddress = parsedArgs[2];
    // If the device number is not 8, throw an error.
    if (device !== "8") throw new $0aba7663dfb52ff8$export$40ed5092119045f8();
    // If the secondary address is not 0 or 1, throw an error.
    if (secondaryAddress !== "0" && secondaryAddress !== "1") throw new $0aba7663dfb52ff8$export$985361d9917e9b3();
    if (program === "$") {
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = null;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedDirectory = "programs";
    } else if (program === "*") {
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = (0, $8a880d67ea505346$export$7f4c6ae6cd2bdde3)[0];
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedDirectory = null;
    } else {
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = (0, $8a880d67ea505346$export$7f4c6ae6cd2bdde3).find((prog)=>prog.name.toUpperCase() === program);
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedDirectory = null;
    }
    // If the program is not found, throw an error.
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram && program !== "$" && program !== "*") {
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = null;
        throw new $0aba7663dfb52ff8$export$8ed883a370ca9eb3();
    }
    // Simulate a load delay, depending on the program size.
    // The delay should be at least 1 second and at most 10 seconds.
    // The delay is calculated as a percentage of the program size.
    // The program size is in lines, so we multiply it by 100ms.
    // If it is a directory listing, the size is 0 and we set a random initial delay between 5 and 20 lines.
    const programSize = (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram ? (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram.size : (0, $584aeef362e2949c$export$3c5f89dae98e900b)(5, 20);
    const loadDelay = Math.max(1000, Math.min(10000, programSize * 100));
    await (0, $584aeef362e2949c$export$88e5af016aee27e)("");
    await (0, $584aeef362e2949c$export$88e5af016aee27e)(`SEARCHING FOR ${program}`, {
        lineDelay: (0, $584aeef362e2949c$export$3c5f89dae98e900b)(2000, 5000)
    });
    await (0, $584aeef362e2949c$export$88e5af016aee27e)("LOADING", {
        lineDelay: loadDelay
    });
};
/**
 * Parses a string of input arguments, separating them into an array of values.
 * The first argument must be enclosed in double quotes, while subsequent arguments
 * can be either quoted or unquoted, separated by commas.
 *
 * @param {string} input - The input string containing arguments to parse.
 * @returns {string[]} An array of parsed arguments. Returns an empty array if the first argument is not quoted.
 */ const $6cbaab98018a1399$var$parseArgs = (input)=>{
    // This regex matches either a quoted group or a non-quoted value up to a comma.
    const regex = /"([^"]+)"|([^,]+)/g;
    const args = [];
    let match;
    let isFirst = true;
    while((match = regex.exec(input)) !== null){
        if (isFirst) {
            // The first argument must be captured by the quoted group.
            if (match[1] === undefined) return [];
            isFirst = false;
        }
        // Use the quoted capture if available; otherwise, the unquoted capture.
        const arg = match[1] !== undefined ? match[1] : match[2];
        args.push(arg.trim());
    }
    return args;
};




const $39188df504fe8773$export$889ea624f2cb2c57 = async (args)=>{
    if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram !== null) {
        if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram.name === "BASIC") (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).mode = (0, $fdd4cfefad56b47a$export$4a6bdc0a840be00).BASIC;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready = false;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = true;
        await (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram.run(args);
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready = true;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = false;
    }
    await (0, $584aeef362e2949c$export$88e5af016aee27e)();
};






const $7fb27851de8bb0b7$export$8837f4fc672e936d = async ()=>{
    if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram !== null) await $7fb27851de8bb0b7$var$listProgram();
    else if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedDirectory !== null) await $7fb27851de8bb0b7$var$listDirectory();
    else await (0, $584aeef362e2949c$export$88e5af016aee27e)();
};
const $7fb27851de8bb0b7$var$listDirectory = async ()=>{
    await (0, $584aeef362e2949c$export$88e5af016aee27e)();
    await (0, $584aeef362e2949c$export$88e5af016aee27e)((0, $584aeef362e2949c$export$51e59903ef341877)("0 [bg=default_fg,fg=default_bg]\"DSS SOLUTIONS  \" 00 2A[/]"));
    // Loop through all programs and print their names.
    for (const program of (0, $8a880d67ea505346$export$7f4c6ae6cd2bdde3)){
        const spaces = " ".repeat(5 - program.size.toString().length);
        let line = program.size + spaces + "\"" + program.name.toUpperCase() + "\"";
        const cells = (0, $dcc66b297d4615da$export$fe9cd68599a979f2)(line);
        const paddedCells = (0, $dcc66b297d4615da$export$b19f13703ed1a836)(cells, 23, 'left');
        line = (0, $dcc66b297d4615da$export$56a312d8b4726b1d)(paddedCells);
        await (0, $584aeef362e2949c$export$88e5af016aee27e)(line + "PRG");
    }
    // Calculate the 'blocks free'. This should be 664 minus the size of all programs.
    const totalSize = (0, $8a880d67ea505346$export$7f4c6ae6cd2bdde3).reduce((acc, program)=>acc + program.size, 0);
    const blocksFree = 664 - totalSize;
    await (0, $584aeef362e2949c$export$88e5af016aee27e)(blocksFree + " BLOCKS FREE.");
};
const $7fb27851de8bb0b7$var$listProgram = async ()=>{
    await (0, $584aeef362e2949c$export$88e5af016aee27e)();
    const program = (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram;
    if (program === null || program === undefined) return;
    await program.list();
};








const $f8a51dc135d76af5$export$c554410d51f629fb = {
    pc: 0,
    goto: null // GOTO line number
};
let $f8a51dc135d76af5$export$4d6f4471ea5b0c92 = {
    name: "BASIC",
    size: 0,
    lines: [],
    list: async function() {
        await $f8a51dc135d76af5$var$listProgram(this.lines);
    },
    run: async function() {
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).running = true;
        await $f8a51dc135d76af5$var$runProgram(this.lines);
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).running = false;
    }
};
const $f8a51dc135d76af5$var$runProgram = async (lines)=>{
    $f8a51dc135d76af5$var$resetSettings(); // Reset the BASIC settings.
    try {
        let ic = 0; // Iteration counter
        while($f8a51dc135d76af5$export$c554410d51f629fb.pc < lines.length){
            // **Yield control to the browser**  
            // This small delay allows the event loop to process pending events (like the ESC key)
            if (ic % 10 === 0) await new Promise((resolve)=>setTimeout(resolve, 0));
            else await Promise.resolve();
            ic++;
            const line = lines[$f8a51dc135d76af5$export$c554410d51f629fb.pc];
            // Check if the line is empty.
            if (line === null || line === undefined || line.trim().length === 0) {
                $f8a51dc135d76af5$export$c554410d51f629fb.pc++;
                continue;
            }
            // Check if the program should be stopped. Break if the ESC key is pressed on the next command.
            if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).running) {
                await (0, $584aeef362e2949c$export$88e5af016aee27e)("BREAK IN " + $f8a51dc135d76af5$export$c554410d51f629fb.pc);
                break;
            }
            await $f8a51dc135d76af5$var$executeLine(line, $f8a51dc135d76af5$export$c554410d51f629fb.pc);
            // Check if a GOTO command was issued.
            if ($f8a51dc135d76af5$export$c554410d51f629fb.goto !== null) {
                const target = $f8a51dc135d76af5$export$c554410d51f629fb.goto;
                $f8a51dc135d76af5$export$c554410d51f629fb.goto = null; // Reset the goto state.
                // Check if the line exists in the lines array.
                if (lines[target] === undefined || lines[target] === null) throw new (0, $0aba7663dfb52ff8$export$6dd8bd6e07dce31b)(); // Line does not exist.
                // If the line exists, update the program counter to jump to the target line.
                $f8a51dc135d76af5$export$c554410d51f629fb.pc = target; // No need to decrement because we will increment it at the end of the loop.
                continue; // Skip the rest of the loop and jump to the target line.
            }
            // Increment the program counter.
            $f8a51dc135d76af5$export$c554410d51f629fb.pc++;
        }
    } catch (error) {
        if (error instanceof (0, $0aba7663dfb52ff8$export$dbf2365ccb60f5d)) await error.handleError();
        else if (error instanceof (0, $0aba7663dfb52ff8$export$a490eb03cb7a0a5e)) await error.handleError();
        else {
            console.error(error);
            await new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)().handleError();
        }
    }
};
const $f8a51dc135d76af5$var$resetSettings = ()=>{
    $f8a51dc135d76af5$export$c554410d51f629fb.pc = 0; // Reset the program counter.
    $f8a51dc135d76af5$export$c554410d51f629fb.goto = null; // Reset the GOTO line number.
};
const $f8a51dc135d76af5$var$executeLine = async (line, lineNumber)=>{
    line = line.trim();
    // Check if the line is empty.
    if (line.length === 0) return;
    // Get all command keys and sort them descending by length.
    // Sorting by length ensures that longer commands (e.g., PRINT#) are tried before shorter ones.
    const commandKeys = Object.keys((0, $c973ce7613e80019$export$2ccc4f72dd956183)).sort((a, b)=>b.length - a.length);
    let foundCommand = null;
    let args = "";
    // Try to match a command key at the very start of the input.
    for (const key of commandKeys)// Compare in a case-insensitive manner.
    if (line.toUpperCase().startsWith(key.toUpperCase())) {
        // Command match found.
        foundCommand = key;
        // Extract the arguments by slicing the input after the command key.
        args = line.slice(key.length).trim();
        break;
    }
    try {
        if (foundCommand) // Execute the matched command with the extracted arguments.
        await (0, $c973ce7613e80019$export$2ccc4f72dd956183)[foundCommand](args);
        else // If no command is found, handle it as a syntax error.
        throw new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)();
    } catch (error) {
        throw new (0, $0aba7663dfb52ff8$export$dbf2365ccb60f5d)(error.message, lineNumber);
    }
};
const $f8a51dc135d76af5$var$listProgram = async (lines)=>{
    // Loop through all lines in the custom program and print them.
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        if (line === null || line === undefined) continue;
        await (0, $584aeef362e2949c$export$88e5af016aee27e)(i + " " + line);
    }
};


const $72383cabbf5beab8$export$e64e955830870e84 = async (args)=>{
    let lineNumber = 0; // Initialize lineNumber to 0.
    // Remove all spaces from args.
    args = args.replace(/\s/g, "");
    // Check if args is empty.
    if (args !== undefined && args.length > 0) {
        // Parse the args to a number. All digits up to the first non-digit character make up the line number.
        // For example, "123abc" becomes 123.
        const match = args.match(/^\d+/); // Match one or more digits at the start of the string.
        if (!match) // If no digits are found, throw a syntax error.
        throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
        lineNumber = parseInt(match[0], 10); // Convert the matched digits to an integer.    
    }
    if (isNaN(lineNumber)) // If the line number is not a number, throw a syntax error.
    throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    // Check if the line number is within the valid range.
    if (lineNumber < 0 || lineNumber > (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).maxLineNumber) throw new $0aba7663dfb52ff8$export$f21cea08b0dd60e8();
    (0, $f8a51dc135d76af5$export$c554410d51f629fb).goto = lineNumber;
};





const $3524c89abcf395e3$export$2100ae395bb25b4f = async ()=>{
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedDirectory = null;
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = null;
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).mode = (0, $fdd4cfefad56b47a$export$4a6bdc0a840be00).INPUT;
    (0, $f8a51dc135d76af5$export$4d6f4471ea5b0c92).lines = [];
    await (0, $584aeef362e2949c$export$88e5af016aee27e)();
};


const $c973ce7613e80019$var$processUnsupportedCommand = async ()=>await new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)().handleError();
const $c973ce7613e80019$var$unsupportedCommand = $c973ce7613e80019$var$processUnsupportedCommand;
const $c973ce7613e80019$export$2ccc4f72dd956183 = {
    CLOSE: $c973ce7613e80019$var$unsupportedCommand,
    CLR: $c973ce7613e80019$var$unsupportedCommand,
    CMD: $c973ce7613e80019$var$unsupportedCommand,
    CONT: $c973ce7613e80019$var$unsupportedCommand,
    DATA: $c973ce7613e80019$var$unsupportedCommand,
    DEF: $c973ce7613e80019$var$unsupportedCommand,
    DIM: $c973ce7613e80019$var$unsupportedCommand,
    END: $c973ce7613e80019$var$unsupportedCommand,
    FOR: $c973ce7613e80019$var$unsupportedCommand,
    GET: $c973ce7613e80019$var$unsupportedCommand,
    "GET#": $c973ce7613e80019$var$unsupportedCommand,
    GOSUB: $c973ce7613e80019$var$unsupportedCommand,
    GOTO: async (args)=>await (0, $72383cabbf5beab8$export$e64e955830870e84)(args),
    IF: $c973ce7613e80019$var$unsupportedCommand,
    INPUT: $c973ce7613e80019$var$unsupportedCommand,
    "INPUT#": $c973ce7613e80019$var$unsupportedCommand,
    LET: $c973ce7613e80019$var$unsupportedCommand,
    LIST: async ()=>await (0, $7fb27851de8bb0b7$export$8837f4fc672e936d)(),
    LOAD: async (args)=>await (0, $6cbaab98018a1399$export$11e63f7b0f3d9900)(args),
    NEW: async (args)=>await (0, $3524c89abcf395e3$export$2100ae395bb25b4f)(args),
    NEXT: $c973ce7613e80019$var$unsupportedCommand,
    ON: $c973ce7613e80019$var$unsupportedCommand,
    OPEN: $c973ce7613e80019$var$unsupportedCommand,
    POKE: $c973ce7613e80019$var$unsupportedCommand,
    "?": async (args)=>await (0, $888fe5edcd3affc9$export$c2d084dc44961371)(args),
    PRINT: async (args)=>await (0, $888fe5edcd3affc9$export$c2d084dc44961371)(args),
    "PRINT#": $c973ce7613e80019$var$unsupportedCommand,
    READ: $c973ce7613e80019$var$unsupportedCommand,
    REM: $c973ce7613e80019$var$unsupportedCommand,
    RESTORE: $c973ce7613e80019$var$unsupportedCommand,
    RETURN: $c973ce7613e80019$var$unsupportedCommand,
    RUN: async (args)=>await (0, $39188df504fe8773$export$889ea624f2cb2c57)(args),
    SAVE: $c973ce7613e80019$var$unsupportedCommand,
    ST: $c973ce7613e80019$var$unsupportedCommand,
    STATUS: $c973ce7613e80019$var$unsupportedCommand,
    STEP: $c973ce7613e80019$var$unsupportedCommand,
    STOP: $c973ce7613e80019$var$unsupportedCommand,
    SYS: $c973ce7613e80019$var$unsupportedCommand,
    THEN: $c973ce7613e80019$var$unsupportedCommand,
    TO: $c973ce7613e80019$var$unsupportedCommand,
    VERIFY: $c973ce7613e80019$var$unsupportedCommand,
    WAIT: $c973ce7613e80019$var$unsupportedCommand
};
const $c973ce7613e80019$export$f5bd41ed0736d1dc = (command)=>$c973ce7613e80019$export$2ccc4f72dd956183.hasOwnProperty(command) && $c973ce7613e80019$export$2ccc4f72dd956183[command] !== $c973ce7613e80019$var$unsupportedCommand;






const $6d5084239ae1c0cb$export$ca996cbdad146a3d = (key)=>{
    // If not ready, ignore the key.
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready) return;
    // Push the key to the current input.
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput.push(new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(key.toUpperCase()));
    // Push the key to the current line.
    // Add a new line if the line doesn't exist yet.
    if (!(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]]) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]] = (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).emptyLine();
    // If the current line is full, move to the next line.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]][(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]] = new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(key.toUpperCase());
    // Update the cursor position.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]++;
    // If the cursor position exceeds the number of columns, move to the next line.
    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] >= (0, $7c272bbd353d7892$export$53b3c91859018cd4)) {
        (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
        (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
    }
    // If the cursor position exceeds the number of rows, move all lines up one line and reset the cursor position to last line.
    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) $6d5084239ae1c0cb$export$96e75e214ecc8805();
};
const $6d5084239ae1c0cb$export$6f6ab53131f31942 = async (processCommand = true)=>{
    // If not ready, ignore the key.
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready) return;
    // Move the cursor to the start of the next line.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
    // If the cursor position exceeds the number of rows, move all lines up one line and reset the cursor position to last line.
    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) $6d5084239ae1c0cb$export$96e75e214ecc8805();
    // If the command must be processed, we need to convert the current input into a string.
    if (processCommand) $6d5084239ae1c0cb$export$5706ff7930225f56((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput);
    // Reset the current input.
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput = [];
};
const $6d5084239ae1c0cb$export$eb17915dcef47f20 = ()=>{
    // If not ready, ignore the key.
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready) return;
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput = (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput.slice(0, -1);
    // Remove the last character from the current line.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines[(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]][(0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] - 1] = new (0, $dcc66b297d4615da$export$f6f0c3fe4ec306ea)(" ");
    // Move the cursor to the left.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]--;
    // If the cursor position is less than 0, set it to 0. It cannot move to a previous line.
    if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] < 0) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
};
const $6d5084239ae1c0cb$export$5706ff7930225f56 = async (input)=>{
    // If the input is an array of cells, convert it to a string.
    if (Array.isArray(input)) input = (0, $dcc66b297d4615da$export$56a312d8b4726b1d)(input);
    input = input.trim();
    if (input === "") return;
    // Check if the first character(s) of the input is a number.
    // If it is, it is a line number. That means we're in program mode.
    // If the first character(s) is not a number, we're in input mode.
    // check first character(s) of the input
    if (!isNaN(input[0])) {
        await $6d5084239ae1c0cb$var$processProgramInput(input);
        return;
    }
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).mode = (0, $fdd4cfefad56b47a$export$4a6bdc0a840be00).INPUT;
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready = false;
    (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = true;
    // Get all command keys and sort them descending by length.
    // Sorting by length ensures that longer commands (e.g., PRINT#) are tried before shorter ones.
    const commandKeys = Object.keys((0, $c973ce7613e80019$export$2ccc4f72dd956183)).sort((a, b)=>b.length - a.length);
    let foundCommand = null;
    let args = "";
    // Try to match a command key at the very start of the input.
    for (const key of commandKeys)// Compare in a case-insensitive manner.
    if (input.toUpperCase().startsWith(key.toUpperCase())) {
        // Command match found.
        foundCommand = key;
        // Extract the arguments by slicing the input after the command key.
        args = input.slice(key.length).trim();
        break;
    }
    try {
        if (foundCommand) // Execute the matched command with the extracted arguments.
        await (0, $c973ce7613e80019$export$2ccc4f72dd956183)[foundCommand](args);
        else // If no command is found, handle it as a syntax error.
        throw new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)();
    } catch (error) {
        // Handle specific error types if needed.
        if (error instanceof (0, $0aba7663dfb52ff8$export$a490eb03cb7a0a5e)) await error.handleError();
        else {
            console.error(error);
            await new (0, $0aba7663dfb52ff8$export$f21cea08b0dd60e8)().handleError();
        }
    } finally{
        // Reset the state to ready and unblock the cursor.
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready = true;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).blockCursor = false;
        // Reset the current input.
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).currentInput = [];
        await (0, $584aeef362e2949c$export$88e5af016aee27e)("READY.");
    }
};
const $6d5084239ae1c0cb$var$processProgramInput = async (input)=>{
    // Convert the input to a string.
    if (Array.isArray(input)) input = (0, $dcc66b297d4615da$export$56a312d8b4726b1d)(input);
    input = input.trim();
    // Get the line number from the input. Line number can be any number.
    // To get the line number, we need to find the first non-number character.
    const lineNumberMatch = input.match(/^(\d+)\s*/); // Match one or more digits at the start of the string.
    if (lineNumberMatch) {
        const lineNumber = parseInt(lineNumberMatch[1], 10); // Convert the matched line number to an integer.
        // Get the rest of the input as the program line.
        const programLine = input.slice(lineNumberMatch[0].length).trim();
        // If the program line is empty, remove the line from the custom program.
        if (programLine === "") delete (0, $f8a51dc135d76af5$export$4d6f4471ea5b0c92).lines[lineNumber];
        else // Store the line number and program line in the custom program.
        (0, $f8a51dc135d76af5$export$4d6f4471ea5b0c92).lines[lineNumber] = programLine;
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).loadedProgram = (0, $f8a51dc135d76af5$export$4d6f4471ea5b0c92);
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).mode = (0, $fdd4cfefad56b47a$export$4a6bdc0a840be00).BASIC;
    }
};
const $6d5084239ae1c0cb$export$ae2e86d0630ef591 = (e)=>{
    // If not ready, ignore the key.
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready) return;
    // Move the cursor in the specified direction.
    switch(e.key){
        case "ArrowUp":
            (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]--;
            if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] < 0) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] = 0;
            break;
        case "ArrowDown":
            (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0]++;
            if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] >= (0, $7c272bbd353d7892$export$2dd197b55cf13440)) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] = (0, $7c272bbd353d7892$export$2dd197b55cf13440) - 1;
            break;
        case "ArrowLeft":
            (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]--;
            if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] < 0) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = 0;
            break;
        case "ArrowRight":
            (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1]++;
            if ((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] >= (0, $7c272bbd353d7892$export$53b3c91859018cd4)) (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[1] = (0, $7c272bbd353d7892$export$53b3c91859018cd4) - 1;
            break;
    }
};
const $6d5084239ae1c0cb$export$96e75e214ecc8805 = ()=>{
    // Move all lines up one line.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines.shift();
    // Add a new empty line at the end.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).lines.push((0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).emptyLine());
    // Reset the cursor position to the last line.
    (0, $8c5fe36f99ec85f1$export$be623a1d3e871e62).cursorPosition[0] = (0, $7c272bbd353d7892$export$2dd197b55cf13440) - 1;
};



// Ensure fonts are loaded before initial render.
document.fonts.ready.then(()=>{
    (0, $bb03cfb7ed2a4fd8$export$59b33278b5b2fc8a)();
    $74bee796bdfabb9d$var$setupIntervals();
});
window.addEventListener('resize', (0, $bb03cfb7ed2a4fd8$export$59b33278b5b2fc8a));
// Capture keyboard input.
document.addEventListener('keydown', async (e)=>{
    if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).waitingForKeyPress) {
        // If waiting for a key press, resolve the promise and stop further processing.
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).waitingForKeyPress = false; // Reset the flag
        if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).keyPressResolve) {
            (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).keyPressResolve(e.key); // Resolve the promise with the key pressed
            (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).keyPressResolve = null; // Clear the resolve function
        }
        return;
    }
    if (e.key === "Escape") {
        if ((0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).running) (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).running = false;
    }
    if (!(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).ready) return;
    // Append printable characters (converted to uppercase).
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) (0, $6d5084239ae1c0cb$export$ca996cbdad146a3d)(e.key);
    else if (e.key === "Backspace") {
        (0, $6d5084239ae1c0cb$export$eb17915dcef47f20)();
        e.preventDefault(); // Prevent default browser behavior.
    } else if (e.key === "Enter") (0, $6d5084239ae1c0cb$export$6f6ab53131f31942)();
    else if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") {
        // Handle up arrow key.
        (0, $6d5084239ae1c0cb$export$ae2e86d0630ef591)(e);
        e.preventDefault(); // Prevent default browser behavior.
    }
});
const $74bee796bdfabb9d$var$setupIntervals = ()=>{
    // Blink the cursor every 350ms.
    setInterval(()=>{
        (0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).showCursor = !(0, $fdd4cfefad56b47a$export$ca000e230c0caa3e).showCursor;
    }, 350);
    // Render screen at 50fps.
    setInterval((0, $bb03cfb7ed2a4fd8$export$fdfa2e9363bf938e), 1000 / (0, $7c272bbd353d7892$export$e19a55101d8f7602));
};


//# sourceMappingURL=repo.ca6625de.js.map
